import { FormatUtils } from "@my/util";
import { ScrollView, styled, Text, useWindowDimensions, View, XStack, YStack } from "tamagui";
import { VictoryChart, VictoryBar, VictoryTooltip, VictoryAxis, VictoryGroup } from "victory";
import { jsx, jsxs } from "react/jsx-runtime";
const LegendItem = styled(YStack, {
  flexDirection: "row",
  marginHorizontal: 5,
  alignItems: "center"
});
const ColorBox = styled(YStack, {
  width: 10,
  height: 10,
  marginRight: 5,
  borderRadius: 100
});
const Legend = ({
  legendData
}) => /* @__PURE__ */jsx(XStack, {
  marginVertical: 10,
  flexWrap: "wrap",
  children: legendData?.map(item => /* @__PURE__ */jsxs(LegendItem, {
    children: [/* @__PURE__ */jsx(ColorBox, {
      style: {
        backgroundColor: item.fill
      }
    }), /* @__PURE__ */jsx(Text, {
      fontSize: 12,
      children: item.name
    })]
  }, item.name))
});
const GroupedBarChart = props => {
  const {
    barData,
    legendData,
    colorScale
  } = props;
  const {
    width
  } = useWindowDimensions();
  const isWideScreen = width < 500;
  const chartWidth = isWideScreen ? 320 : 400;
  const chartHeight = isWideScreen ? 320 : 320;
  const barWidth = isWideScreen ? 20 : 25;
  return /* @__PURE__ */jsxs(View, {
    children: [legendData && /* @__PURE__ */jsx(Legend, {
      legendData
    }), /* @__PURE__ */jsx(ScrollView, {
      horizontal: true,
      showsHorizontalScrollIndicator: false,
      maxWidth: isWideScreen ? 320 : 500,
      children: /* @__PURE__ */jsxs(VictoryChart, {
        width: chartWidth + 200,
        height: chartHeight,
        domainPadding: {
          x: 20,
          y: 40
        },
        padding: {
          top: 20,
          bottom: 50,
          left: 50,
          right: 50
        },
        children: [/* @__PURE__ */jsx(VictoryGroup, {
          offset: barWidth,
          colorScale,
          children: barData.map(dataset => /* @__PURE__ */jsx(VictoryBar, {
            barWidth,
            data: dataset.data,
            x: "month",
            y: "value",
            labelComponent: /* @__PURE__ */jsx(VictoryTooltip, {}),
            labels: ({
              datum
            }) => `${dataset.name}: ${FormatUtils.currency.cashFormat(datum.value)}`
          }, dataset.name))
        }), /* @__PURE__ */jsx(VictoryAxis, {
          style: {
            axis: {
              stroke: "none"
            },
            tickLabels: {
              fontSize: 10,
              fontWeight: "700"
            }
          }
        }), /* @__PURE__ */jsx(VictoryAxis, {
          dependentAxis: true,
          style: {
            axis: {
              stroke: "none"
            },
            tickLabels: {
              fontSize: 10,
              fontWeight: "700"
            }
          },
          tickFormat: x => {
            if (x >= 1e3) {
              return `$${x / 1e3}k`;
            }
            return `$${x}`;
          }
        })]
      })
    })]
  });
};
export { GroupedBarChart };
//# sourceMappingURL=GroupedBarChart.mjs.map
